// extracted by mini-css-extract-plugin
export default {"whatsappFloat":"WhatsAppFloat_whatsappFloat__32Sci","pulse":"WhatsAppFloat_pulse__C1Tu8","icon":"WhatsAppFloat_icon__CbT5H","shake":"WhatsAppFloat_shake__cuK8S"};